export const ASSETS_PAIRS_URL = "/exchange/pairs-from-klines";
export const SET_BOOKMARKS_URL = "/user/assets-bookmarks/set";
